import * as constants from 'client/redux/endpoint/azureOpenAi/constants';
import { reduceByTypes } from 'client/redux/apiHelpers';

const defaultState = {
  isEditing: false,
  isReading: false,
  isUpdating: false,
  isDeleting: false,
  error: null,
  endpoint: null,
};

export default function reducer (state = defaultState, action) {
  state = reduceByTypes(constants.ENDPOINT_AZURE_OPEN_AI_READ, state, action, {requestProp: 'isReading', successSpread: true});
  state = reduceByTypes(constants.ENDPOINT_AZURE_OPEN_AI_UPDATE_SETTINGS, state, action, {requestProp: 'isUpdating', successSpread: true});
  switch (action.type) {
    default: return state;
    case constants.ENDPOINT_AZURE_OPEN_AI_EDIT_SETTINGS: return {
      ...state,
      isEditing: action.isEditing,
    };
    case constants.ENDPOINT_AZURE_OPEN_AI_PRELOADED: return {
      ...state,
      isReading: false,
      endpoint: action.endpoint,
      error: null,
    };
  }
}
